<script setup lang="ts">
import { DialogContent, DialogPortal, DialogRoot, DialogTrigger } from "reka-ui";
</script>

<template>
  <DialogRoot>
    <DialogTrigger as-child>
      <UiNavButton as="button">
        <span class="i-local-search" />
      </UiNavButton>
    </DialogTrigger>
    <UiDialogOverlay />
    <DialogPortal to="#header-mobile">
      <DialogContent class="animation-fade item-center wp-top-0 fixed inset-x-0 flex justify-center bg-light">
        <SiteHeaderSearch class="w-full" />
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
